<script>
import ActivityCard from './activity-card.vue';
import { HotelBedsExportService } from '@/services/hotelbeds-export.service.js';

export default {
    components: {
        ActivityCard
    },
    props: {
        results: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        hasError: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasResults() {
            return this.results && Object.keys(this.results).length > 0;
        },
        activities() {
            return this.results?.activities || [];
        },
        totalActivities() {
            return this.activities.length;
        }
    },
    methods: {
        downloadExcel() {
            try {
                if (this.activities.length === 0) {
                    this.$bvToast.toast('No hay actividades para exportar', {
                        title: 'Advertencia',
                        variant: 'warning',
                        solid: true,
                        autoHideDelay: 3000
                    });
                    return;
                }
                
                const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
                const filename = `hotelbeds-activities-${timestamp}`;
                
                HotelBedsExportService.exportActivitiesToExcel(this.activities, filename);
                
                this.$bvToast.toast('Archivo Excel generado correctamente', {
                    title: 'Éxito',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 3000
                });
                
            } catch (error) {
                console.error('Error downloading Excel:', error);
                this.$bvToast.toast('Error al generar el archivo Excel', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 3000
                });
            }
        }
    }
};
</script>

<template>
    <div class="card h-100">
        <div class="card-body">
            <h4 class="card-title mb-4">Resultados de la previsualización</h4>
            
            <div v-if="loading" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Cargando...</span>
                </div>
                <p class="mt-2 text-muted">Consultando datos...</p>
            </div>
            
            <div v-else-if="hasError" class="text-center py-4">
                <i class="mdi mdi-alert-circle text-danger" style="font-size: 3rem;"></i>
                <h5 class="mt-2 text-danger">Error en la consulta</h5>
                <p class="text-muted">Ha ocurrido un error al obtener la previsualización</p>
                <small class="text-muted">Verifica los parámetros e intenta nuevamente</small>
            </div>
            
            <div v-else-if="!hasResults" class="text-center py-4">
                <i class="mdi mdi-information-outline text-muted" style="font-size: 3rem;"></i>
                <p class="mt-2 text-muted">No hay resultados para mostrar</p>
                <small class="text-muted">Realiza una consulta para ver los resultados</small>
            </div>
            
            <div v-else>
                <!-- Results Summary -->
                <div class="alert alert-info mb-4">
                    <div class="d-flex justify-content-between align-items-start">
                        <div>
                            <h5 class="alert-heading">
                                <i class="mdi mdi-check-circle mr-2"></i>
                                Consulta completada
                            </h5>
                            <p class="mb-0">
                                Se encontraron <strong>{{ totalActivities }}</strong> actividades disponibles.
                            </p>
                        </div>
                        <button 
                            v-if="totalActivities > 0"
                            @click="downloadExcel"
                            class="btn btn-success btn-sm"
                            title="Descargar en Excel"
                        >
                            <i class="mdi mdi-file-excel mr-1"></i>
                            Exportar Excel
                        </button>
                    </div>
                </div>

                <!-- Activities Grid -->
                <div v-if="totalActivities > 0">
                    <div class="activities-container">
                        <div 
                            v-for="activity in activities" 
                            :key="activity.activityCode || activity.code"
                            class="activity-wrapper mb-4"
                        >
                            <ActivityCard :activity="activity" />
                        </div>
                    </div>
                </div>

                <!-- No Activities Found -->
                <div v-else class="text-center py-4">
                    <i class="mdi mdi-information-outline text-muted" style="font-size: 3rem;"></i>
                    <h5 class="mt-2 text-muted">No se encontraron actividades</h5>
                    <p class="text-muted">No hay actividades disponibles con los criterios de búsqueda especificados.</p>
                </div>
            </div>
        </div>
    </div>
</template> 